function end(working, command, p) {
  working.end = true;
  return working.text;
}
end.key = "end";
end.title = "End";
end.category = "Flow Control";
end.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/end/";
end.description =
  "End the pipeline immediately, returning the working text as-is.";
end.args = [];
end.passthrough = true;

export default end;
